import React, {useEffect, useState} from 'react';
import {Typography} from "@material-tailwind/react";
import _ from "lodash";
import {check} from "./Check";

const Validator = ({state, rules, isChecked}) => {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("خطا در اطلاعات ورودی");

  useEffect(() => {
    if (state) {
      const ruleArray = _.split(rules, "|");
      let isError = false;

      for (let i = 0; i < ruleArray.length; i++) {
        const rule = ruleArray[i];
        const ruleParts = _.split(rule, "=");
        const ruleName = ruleParts[0];
        const ruleOptions = ruleParts[1] || null;

        if (!check(state, ruleName, ruleOptions, setErrorMessage)) {
          isError = true;
          break;
        }
      }
      setError(isError);
    } else {
      if (rules.includes("required")) {
        if (isChecked) {
          setErrorMessage("فیلد ضروری");
          setError(true);
          return; // Exit early as "required" should take priority
        }
      }
      setError(false);
    }

  }, [state, isChecked]);

  return (
    error ?
      <Typography variant="small" color="red">
        {errorMessage}
      </Typography>
      :
      <div></div>
  );
};

export default Validator;